export default __webpack_public_path__ + "static/for-sdrs-4aabb6bb7c1fc5638b8f2dcc7cf2f715.png";